import React, {useEffect, useLayoutEffect, useState} from 'react';
import {
	findUsers,
	putBulkUpdateRoles,
	putUpdateDefaultRole,
	setSelectedUserIds,
	usersListFilteredLicense as setUsersListFilteredLicense, usersListFilteredRole as setUsersListFilteredRole,
	usersListFilteredStatus as setUsersListFilteredStatus
} from '../../../../../actions/usersListActions';
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import Stats from "./components/stats";
import DataList from "../../../../components/data-list";
import DataListHead from "../../../../components/data-list/data-list-head";
import UserListSearch from "./components/users-list-search";
import Icon from "../../../../components/icon";
import LabelSearch from "./components/label-search";
import UserListContent from "./components/users-list-content";
import Button from "../../../../components/button";
import Select from "../../../../components/select";
import SwitchButton from "../../../../components/switch-button";
import {dropDownPosition} from "../../../../utils";
import {isUserListAddCollaboratorsPopupShown} from "../../../../../actions/popupActions";
import SharingDetailsPopup from "../../../sharing/components/sharing-details-popup";
import './index.css';

function UsersList () {

    const [displayStatusFilter, setDisplayStatusFilter] = useState(false);
    const [displayLicenseFilter, setDisplayLicenseFilter] = useState(false);
    const [bulkRoleValue, setBulkRoleValue] = useState("");

    const usersListFilteredStatus = useSelector(state => state.usersListReducer.usersListFilteredStatus);
    const usersListFilteredLicense = useSelector(state => state.usersListReducer.usersListFilteredLicense);
	const usersListFilteredRole = useSelector(state => state.usersListReducer.usersListFilteredRole);
	const findUsersData = useSelector(state => state.usersListReducer.findUsers);
	const selectedUserIds = useSelector(state => state.usersListReducer.selectedUserIds);
	const isBulkUpdatingRole = useSelector(state => state.usersListReducer.isBulkUpdatingRole);
	const profile = useSelector(state => state.profileReducer.getProfile);
	const enteredSearchValue = useSelector(state => state.contactsGroupItemReducer.getEnteredSearchValue);
	const enteredCollaboratorSearchValue = useSelector(state => state.sharingDetailsReducer.enteredCollaboratorSearchValue);

    const dispatch = useDispatch();

    const { t } = useTranslation();

    useLayoutEffect(() => {
	    dropDownPosition(document.querySelector(".data-list__head"), document.querySelector(".data-list__head .filter-status"), document.querySelector(".data-list__head ul"));
    }, [displayStatusFilter]);

	useLayoutEffect(() => {
		dropDownPosition(document.querySelector(".data-list__head"), document.querySelector(".data-list__head .filter-license"), document.querySelector(".data-list__head ul"));
	}, [displayLicenseFilter]);

	useEffect(() => {
		dispatch(findUsers())
	}, [dispatch]);

	useEffect(() => {
		if (selectedUserIds.length === 0) {
			setBulkRoleValue("");
		}
	}, [selectedUserIds]);

	const defaultUserRole = (findUsersData && findUsersData.defaultUserRole) || (profile && profile.defaultUserRole) || 'USER';
	const isDefaultRestricted = defaultUserRole === 'RESTRICTED_USER';

	const handleToggleDefaultRole = () => {
		if (!profile || profile.role !== 'ADMINISTRATOR') {
			return;
		}
		const nextRole = isDefaultRestricted ? 'USER' : 'RESTRICTED_USER';
		dispatch(putUpdateDefaultRole(nextRole));
	};

	const getVisibleSelectableUserIds = () => {
		if (!findUsersData || !findUsersData.users) {
			return [];
		}
		return findUsersData.users
			.filter(u => {
				if (u.role === 'ADMINISTRATOR' || u.editable === false) {
					return false;
				}
				if (enteredCollaboratorSearchValue && !u.name.toLowerCase().includes(enteredCollaboratorSearchValue.toLowerCase())) {
					return false;
				}
				if (enteredSearchValue) {
					const hasMatchingLabel = u.labels && u.labels.some(l => l.name.toLowerCase().includes(enteredSearchValue.toLowerCase()));
					if (!hasMatchingLabel) {
						return false;
					}
				}
				return true;
			})
			.map(u => u.id);
	};

	const handleSelectAllUsers = (e) => {
		if (e) {
			e.preventDefault();
		}
		const selectableIds = getVisibleSelectableUserIds();
		if (selectableIds.length === 0) {
			return;
		}
		const allSelected = selectableIds.every(id => selectedUserIds.includes(id));
		if (allSelected) {
			dispatch(setSelectedUserIds([]));
		} else {
			dispatch(setSelectedUserIds(selectableIds));
		}
	};

	const handleGlobalRoleChange = (e) => {
		const targetRole = e.currentTarget.value;
		setBulkRoleValue(targetRole);
	};

	const handleApplyBulkRoleChange = () => {
		if (bulkRoleValue && selectedUserIds.length > 0 && !isBulkUpdatingRole) {
			dispatch(putBulkUpdateRoles(selectedUserIds, bulkRoleValue));
		}
	};

    const displayUsersListFilteredStatus = (e) => {

	    const value = e.currentTarget.dataset.value;

	    if(usersListFilteredRole !== null){
		    if(usersListFilteredLicense !== null) {
			    dispatch(findUsers(value, usersListFilteredLicense, usersListFilteredRole));
		    } else {
			    dispatch(findUsers(value, null, usersListFilteredRole));
		    }
	    } else {
		    if(usersListFilteredLicense !== null) {
			    dispatch(findUsers(value, usersListFilteredLicense));
		    } else {
			    dispatch(findUsers(value));
		    }
	    }


        dispatch(setUsersListFilteredStatus(value));

    };

    const displayUsersListFilteredLicense = (e) => {

	    const value = e.currentTarget.dataset.value;

	    if(usersListFilteredRole !== null){
		    if(usersListFilteredStatus !== null){
			    dispatch(findUsers(usersListFilteredStatus, value, usersListFilteredRole));
		    } else {
			    dispatch(findUsers(null, value, usersListFilteredRole));
		    }
	    } else {
		    if(usersListFilteredStatus !== null){
			    dispatch(findUsers(usersListFilteredStatus, value, usersListFilteredRole));
		    } else {
			    dispatch(findUsers(null, value, usersListFilteredRole));
		    }
	    }


        dispatch(setUsersListFilteredLicense(value));
    };

    const removeStatusFilter = (e) => {
        e.stopPropagation();
        dispatch(setUsersListFilteredStatus(null));
        if(usersListFilteredRole !== null){
	        if(usersListFilteredLicense !== null){
		        dispatch(findUsers(null, usersListFilteredLicense, usersListFilteredRole));
	        } else {
		        dispatch(findUsers(null, null, usersListFilteredRole));
	        }
        } else {
	        if(usersListFilteredLicense !== null){
		        dispatch(findUsers(null, usersListFilteredLicense));
	        } else {
		        dispatch(findUsers());
	        }
        }
    };

    const removeLicenseFilter = (e) => {
        e.stopPropagation();
        dispatch(setUsersListFilteredLicense(null));
	    if(usersListFilteredRole !== null){
		    if(usersListFilteredStatus !== null){
			    dispatch(findUsers(usersListFilteredStatus, null, usersListFilteredRole));
		    } else {
			    dispatch(findUsers(null, null, usersListFilteredRole));
		    }
	    } else {
		    if(usersListFilteredStatus !== null){
			    dispatch(findUsers(usersListFilteredStatus));
		    } else {
			    dispatch(findUsers());
		    }
	    }

    };

    const handlerStatusFilter = () => {
    	if(!displayStatusFilter){
		    setDisplayStatusFilter(true);
	    } else {
		    setDisplayStatusFilter(false);
	    }
    };

    const handlerLicenseFilter = () => {
	    if(!displayLicenseFilter){
		    setDisplayLicenseFilter(true);
	    } else {
		    setDisplayLicenseFilter(false);
	    }
    };

    const mouseLeaveHandler = () => {
        setDisplayStatusFilter(false);
        setDisplayLicenseFilter(false);
    };

    const handleAddCollaborator = () => {
        dispatch(isUserListAddCollaboratorsPopupShown(true));
    };

    const handleClickFilterRole = (value) => {

	    dispatch(setUsersListFilteredRole(value));

    	if(value){
		    if(usersListFilteredLicense){
			    if(usersListFilteredStatus !== null){
				    dispatch(findUsers(usersListFilteredStatus, usersListFilteredLicense, value));
			    } else {
				    dispatch(findUsers(null, usersListFilteredLicense, value));
			    }
		    } else {
			    if(usersListFilteredStatus !== null){
				    dispatch(findUsers(usersListFilteredStatus, null, value));
			    } else {
				    dispatch(findUsers(null, null, value));
			    }
		    }
	    } else {
		    if(usersListFilteredLicense){
			    if(usersListFilteredStatus !== null){
				    dispatch(findUsers(usersListFilteredStatus, usersListFilteredLicense));
			    } else {
				    dispatch(findUsers(null, usersListFilteredLicense));
			    }
		    } else {
			    if(usersListFilteredStatus !== null){
				    dispatch(findUsers(usersListFilteredStatus, null));
			    } else {
				    dispatch(findUsers());
			    }
		    }
	    }
    };

    return (
        <div className="users-list container p-4">
            <h2>{t("textAdminLicenses", "Users & Licenses")}</h2>
            <h3>{t("manageUsersAndLicensesSubtitle", "Manage your users and licenses")}</h3>
            <Stats/>
			<SharingDetailsPopup/>
            <div className="my-3 d-flex align-items-center flex-wrap justify-content-between">
	            <div className="tabs mb-2 mb-md-0">
		            <ul className="nav nav-pills">
			            <li className="nav-item">
				            <Button onClick={ () => handleClickFilterRole(null) } className={`nav-link${usersListFilteredRole === null ? ' active' : ''}`}>{t("viewAll", "View all")}</Button>
			            </li>
			            <li className="nav-item">
				            <Button onClick={ () => handleClickFilterRole('USER') } className={`nav-link${usersListFilteredRole === "USER" ? ' active' : ''}`}>{t("roleUser", "User")}</Button>
			            </li>
			            <li className="nav-item">
				            <span
				                className="cf-tooltip-wrap"
				                data-tooltip={t("tooltipFilterRestrictedUsers", "Filter users who have the Restricted User role (cannot share labels or consume extra licenses).")}
				            >
				                <Button onClick={ () => handleClickFilterRole('RESTRICTED_USER') } className={`nav-link${usersListFilteredRole === "RESTRICTED_USER" ? ' active' : ''}`}>{t("roleRestrictedUser", "Restricted User")}</Button>
				            </span>
			            </li>
			            <li className="nav-item">
				            <Button onClick={ () => handleClickFilterRole('ADMINISTRATOR') } className={`nav-link${usersListFilteredRole === "ADMINISTRATOR" ? ' active' : ''}`}>{t("roleAdmin", "Admin")}</Button>
			            </li>
		            </ul>
                </div>
                <div className="d-flex align-items-center flex-wrap">
                    {
                        profile && profile.role === "ADMINISTRATOR" && (
                            <div className="default-role-toggle-box d-flex align-items-center mr-4 px-3 py-2">
                                <span
                                    className="default-role-label mr-2 cf-tooltip-wrap"
                                    data-tooltip={t("tooltipDefaultUserRoleInfo", "Choose the role automatically assigned to any new user joining your domain. Full Users can share labels; Restricted Users cannot share labels or consume extra licenses.")}
                                >
                                    {t("defaultUserRoleLabel", "Default user Role :")}
                                </span>
                                <span
                                    className={`default-role-option cf-tooltip-wrap${!isDefaultRestricted ? ' active' : ''}`}
                                    data-tooltip={t("tooltipDefaultRoleFull", "New users will be Full Users: they can share labels and contacts.")}
                                    onClick={() => isDefaultRestricted && handleToggleDefaultRole()}
                                >
                                    {t("defaultUserRoleFull", "Full")}
                                </span>
                                <span
                                    className="cf-tooltip-wrap"
                                    data-tooltip={t("tooltipDefaultRoleSwitch", "Toggle the default role for new users between Full and Restricted.")}
                                >
                                    <SwitchButton
                                        active={isDefaultRestricted}
                                        onClick={handleToggleDefaultRole}
                                    />
                                </span>
                                <span
                                    className={`default-role-option cf-tooltip-wrap${isDefaultRestricted ? ' active restricted' : ''}`}
                                    data-tooltip={t("tooltipDefaultRoleRestricted", "New users will be Restricted Users: they cannot share labels or consume additional licenses.")}
                                    onClick={() => !isDefaultRestricted && handleToggleDefaultRole()}
                                >
                                    {t("defaultUserRoleRestricted", "Restricted")}
                                </span>
                                <span
                                    className="default-role-info-icon cf-tooltip-wrap cf-tooltip-wrap--left"
                                    data-tooltip={t("tooltipDefaultUserRoleInfo", "Choose the role automatically assigned to any new user joining your domain. Full Users can share labels; Restricted Users cannot share labels or consume extra licenses.")}
                                    aria-label={t("tooltipDefaultUserRoleInfo", "Choose the role automatically assigned to any new user joining your domain.")}
                                >
                                    ?
                                </span>
                            </div>
                        )
                    }
	                <Button className="btn-link font-weight-normal p-0" onClick={handleAddCollaborator}>
		                <svg className="align-text-top mr-2" width="21px" height="21px" viewBox="0 0 21 21">
			                <path fill="#090" d="M10.5,21C4.7,21,0,16.3,0,10.5C0,4.7,4.7,0,10.5,0C16.3,0,21,4.7,21,10.5
								C21,16.3,16.3,21,10.5,21z M10.5,1C5.2,1,1,5.2,1,10.5c0,5.3,4.3,9.5,9.5,9.5c5.3,0,9.5-4.3,9.5-9.5C20,5.2,15.8,1,10.5,1z
								 M11.8,16.3H9.2v-4.5H4.7V9.2h4.5V4.7h2.6v4.5h4.5v2.6h-4.5V16.3z"/>
		                </svg>
		                {t("addLicensedUser", "Add a licensed user")}
	                </Button>
                </div>
            </div>
            {
                profile && profile.role === "ADMINISTRATOR" && (
                    <div className="bulk-role-toolbar d-flex align-items-center justify-content-between px-3 py-2 mb-2">
                        <div className="d-flex align-items-center">
                            <span
                                className="cf-tooltip-wrap cf-tooltip-wrap--right mr-3"
                                data-tooltip={t("tooltipSelectAllUsers", "Select or unselect all non-admin users in the list to update their role in bulk (Administrators cannot be selected).")}
                            >
                                <Button
                                    className="btn-link p-0 font-weight-bold select-all-link"
                                    onClick={handleSelectAllUsers}
                                >
                                    {t("headerSelectAllText", "Select all")}
                                </Button>
                            </span>
                            {selectedUserIds.length > 0 && (
                                <span className="selected-users-counter">
                                    {selectedUserIds.length} {selectedUserIds.length === 1 ? t("userSelectedText", "user selected") : t("usersSelectedText", "users selected")}
                                </span>
                            )}
                        </div>
                        <div className="d-flex align-items-center">
                            <span
                                className="d-flex align-items-center cf-tooltip-wrap cf-tooltip-wrap--left"
                                data-tooltip={
                                    selectedUserIds.length === 0
                                        ? t("tooltipBulkRoleDisabled", "Select one or more users using the checkboxes on the left to update their role in bulk.")
                                        : t("tooltipBulkRoleEnabled", "Select a new role, then click Apply to update all selected users.")
                                }
                            >
                                <label htmlFor="bulk-role-select" className="mb-0 mr-2 text-muted small">
                                    {t("bulkUpdateRoleLabel", "New role for selected users:")}
                                </label>
                                <Select
                                    id="bulk-role-select"
                                    name="bulk-role-select"
                                    value={bulkRoleValue}
                                    disabled={selectedUserIds.length === 0 || isBulkUpdatingRole}
                                    onChange={handleGlobalRoleChange}
                                    style={{
                                        minWidth: "170px",
                                        fontSize: "0.9em",
                                        cursor: (selectedUserIds.length === 0 || isBulkUpdatingRole) ? "not-allowed" : "pointer"
                                    }}
                                >
                                    <option value="" disabled>{t("selectNewRolePlaceholder", "Select new role...")}</option>
                                    <option value="USER">{t("roleUser", "User")}</option>
                                    <option value="RESTRICTED_USER">{t("roleRestrictedUser", "Restricted User")}</option>
                                    <option value="ADMINISTRATOR">{t("roleAdmin", "Admin")}</option>
                                </Select>
                            </span>
                            <span
                                className="ml-2 cf-tooltip-wrap cf-tooltip-wrap--left"
                                data-tooltip={
                                    selectedUserIds.length === 0 || !bulkRoleValue
                                        ? t("tooltipBulkApplyDisabled", "Select users and choose a new role from the dropdown before clicking Apply.")
                                        : t("tooltipBulkApplyEnabled", "Click to validate and apply the selected role to all checked users.")
                                }
                            >
                                <Button
                                    className="btn-primary bulk-role-apply-btn px-3 py-1"
                                    disabled={selectedUserIds.length === 0 || !bulkRoleValue || isBulkUpdatingRole}
                                    onClick={handleApplyBulkRoleChange}
                                >
                                    {t("applyBtn", "Apply")}
                                </Button>
                            </span>
                            {isBulkUpdatingRole && (
                                <span className="ml-2">
                                    <Icon animated={'pulse'} name="spinner"/>
                                </span>
                            )}
                        </div>
                    </div>
                )
            }
            <DataList className={`users-list`}>
                <DataListHead>
                    <div className="col-3">
                        <UserListSearch/>
                    </div>
                    <div className="col-1">
                        {t("roleColumnHeader", "Role")}
                    </div>
                    <div className="filter-status col-2 text-center"
                         onClick={handlerStatusFilter} onMouseLeave={mouseLeaveHandler}>
                        {t("popupSharingStatus")}
                        {usersListFilteredStatus === null && <Icon className="ml-1" name="filter"/>}
                        {
	                        displayStatusFilter && <ul>
                                <li><Button className="btn-link" data-value="normal" onClick={displayUsersListFilteredStatus}><Icon name="check"/> {t("normalText")}</Button></li>
                                <li><Button className="btn-link" data-value="deleted" onClick={displayUsersListFilteredStatus}><Icon name="user-times"/>{t("UserDeletedText")}</Button></li>
                                <li><Button className="btn-link" data-value="suspended" onClick={displayUsersListFilteredStatus}><Icon name="minus-circle"/> {t("UserSuspendedText")}</Button></li>
                                <li><Button className="btn-link" data-value="banned" onClick={displayUsersListFilteredStatus}><Icon name="gavel"/> {t("UserBannedText")}</Button></li>
                                <li><Button className="btn-link" data-value="revoked" onClick={displayUsersListFilteredStatus}><Icon name="times-circle"/> {t("UserRevokedText")}</Button></li>
                                <li><Button className="btn-link" data-value="invitationPending" onClick={displayUsersListFilteredStatus}><Icon name="clock-o"/> {t("InviteSentText")}</Button></li>
                                <li><Button className="btn-link" data-value="unknown" onClick={displayUsersListFilteredStatus}><Icon name="question-circle-o"/> {t("adminScreenStatus8")}</Button></li>
                            </ul>
                        }
                        {
                            usersListFilteredStatus !== null
                                ?
                                <div className="status">
                                    {usersListFilteredStatus === "normal" ? <Icon name="check"/> : ""}
                                    {usersListFilteredStatus === "deleted" ? <Icon name="user-times"/> : ""}
                                    {usersListFilteredStatus === "suspended" ? <Icon name="minus-circle"/> : ""}
                                    {usersListFilteredStatus === "banned" ? <Icon name="gavel"/> : ""}
                                    {usersListFilteredStatus === "revoked" ? <Icon name="times-circle"/> : ""}
                                    {usersListFilteredStatus === "invitationPending" ? <Icon name="clock-o"/> : ""}
                                    {usersListFilteredStatus === "unknown" ? <Icon name="question-circle-o"/> : ""}
                                    <span onClick={removeStatusFilter} className="delete">×</span>
                                </div>
                                :
                                ""
                        }
                    </div>
                    <div className="filter-license col-1 text-center" onClick={handlerLicenseFilter}
                         onMouseLeave={mouseLeaveHandler}>
                        {t("textLicensed")}
                        {usersListFilteredLicense === null && <Icon className="ml-1" name="filter"/>}
                        {
	                        displayLicenseFilter && <ul>
                                <li><Button className="btn-link" data-value="licensed" onClick={displayUsersListFilteredLicense}><Icon name="check"/> {t("textLicensed")}</Button></li>
                                <li><Button className="btn-link" data-value="unusedLicense" onClick={displayUsersListFilteredLicense}><Icon name="times"/> {t("textUnusedLicense")}</Button></li>
                            </ul>
                        }
                        {
                            usersListFilteredLicense !== null
                                ?
                                <div className="status">
                                    {usersListFilteredLicense === "licensed" ? <Icon name="check"/> : ""}
                                    {usersListFilteredLicense === "unusedLicense" ? <Icon name="times"/> : ""}
                                    <span onClick={removeLicenseFilter} className="delete">×</span>
                                </div>
                                :
                                ""
                        }
                    </div>
                    <div className="col-1 "/>
                    <div className="col-2">
                        <LabelSearch/>
                    </div>
                </DataListHead>
                <UserListContent/>
            </DataList>
        </div>
    )
}

export default UsersList;

